import * as svg from "../../../assets/image-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ImageIcon = iconBuilder(svg, "ImageIcon", "0 0 16 16");
